/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RichiestaPraticaEsercenteStatus } from './richiesta-pratica-esercente-status';


export interface PraticaEsercenteEventoDTO { 
    id?: string;
    event_type?: string;
    event_timestamp?: string;
    actor_type?: PraticaEsercenteEventoDTOActorTypeEnum;
    actor?: string;
    stato_da?: RichiestaPraticaEsercenteStatus;
    stato_a?: RichiestaPraticaEsercenteStatus;
    nota?: string;
    canale?: string;
    esito?: string;
}
export enum PraticaEsercenteEventoDTOActorTypeEnum {
    CITTADINO = 'CITTADINO',
    OPERATORE = 'OPERATORE',
    SISTEMA = 'SISTEMA',
    ESTERNO = 'ESTERNO',
    CASSIERE = 'CASSIERE',
    ESERCENTE = 'ESERCENTE'
};



